/**
 ** Returns a Stripe.js instance if Stripe is one of the applicable payment methods.
 * @async
 * @param {Object} paymentMethods - An object containing the available payment methods.
 * @returns {object|null} - A promise that resolves to a Stripe object
 * @throws {Error} If there's an error during the process of fetching the Stripe publishable key or loading Stripe.js.
 */

import {loadStripe} from '@stripe/stripe-js'
import getStripeApiKeys from './get-api-keys'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'

const GetStripePromise = async (getcustomPreferencevalue) => {
    try {
        const StripeApi = await getStripeApiKeys(getcustomPreferencevalue)
        const publishableKey = StripeApi.publishableKey
        return loadStripe(publishableKey)
    } catch (error) {
        logger.error('stripe payment', {
            namespace: 'get-stripe-promise',
            additionalProperties: {error: error.message}
        })
    }
}

export default GetStripePromise
